import React, { createContext, useContext, useState, useEffect } from 'react';

// Language Context
const LanguageContext = createContext();

// Translations for the entire application
export const translations = {
  // Navigation
  nav: {
    home: { es: 'Inicio', en: 'Home' },
    services: { es: 'Servicios', en: 'Services' },
    pricing: { es: 'Precios', en: 'Pricing' },
    blog: { es: 'Blog', en: 'Blog' },
    contact: { es: 'Contacto', en: 'Contact' },
    login: { es: 'Iniciar Sesión', en: 'Login' },
    logout: { es: 'Cerrar Sesión', en: 'Logout' },
    profile: { es: 'Perfil', en: 'Profile' },
    adminPanel: { es: 'Panel Admin', en: 'Admin Panel' }
  },
  
  // Service names
  services: {
    restaurants: { es: 'Restaurantes', en: 'Restaurants' },
    realEstate: { es: 'Inmobiliaria', en: 'Real Estate' },
    finance: { es: 'Servicios Financieros', en: 'Finance Support' },
    advocacy: { es: 'Servicios Jurídicos', en: 'Advocacy Services' },
    importExport: { es: 'Importación/Exportación', en: 'Import/Export' }
  },

  // Restaurants page
  restaurants: {
    heroTitle: { 
      es: 'Restaurantes Indios Premium en Madrid', 
      en: 'Premium Indian Restaurants in Madrid' 
    },
    heroSubtitle: { 
      es: 'Descubre nuestros restaurantes de cocina india auténtica en Madrid. Experiencias gastronómicas excepcionales con los mejores chefs y especias importadas.',
      en: 'Discover our authentic Indian cuisine restaurants in Madrid. Exceptional dining experiences with the best chefs and imported spices.'
    },
    sectionTitle: { 
      es: 'Nuestros Restaurantes en Madrid', 
      en: 'Our Restaurants in Madrid' 
    },
    sectionSubtitle: { 
      es: 'Descubre experiencias gastronómicas excepcionales en nuestra colección de restaurantes indios en España',
      en: 'Discover exceptional dining experiences in our collection of Indian restaurants in Spain'
    },
    cuisine: { es: 'Cocina', en: 'Cuisine' },
    indianCuisine: { es: 'Cocina India', en: 'Indian Cuisine' },
    comingSoon: { es: 'Próximamente', en: 'Coming Soon' },
    visitWebsite: { es: 'Visitar Web', en: 'Visit Website' },
    openingSoon: { es: 'Abriendo Pronto', en: 'Opening Soon' },
    whyChooseTitle: { 
      es: 'Por Qué Elegir Nuestros Restaurantes en Madrid', 
      en: 'Why Choose Our Restaurants in Madrid' 
    },
    whyChooseSubtitle: { 
      es: 'Cada restaurante de SP BD Group ofrece excelencia a través de calidad, autenticidad y servicio excepcional en España',
      en: 'Every SP BD Group restaurant delivers excellence through quality, authenticity and exceptional service in Spain'
    },
    qualityIngredients: { es: 'Ingredientes de Calidad Premium', en: 'Premium Quality Ingredients' },
    qualityDesc: { es: 'Ingredientes frescos y premium de los mejores proveedores de India y España', en: 'Fresh, premium ingredients from the best suppliers in India and Spain' },
    authenticRecipes: { es: 'Recetas Auténticas de la India', en: 'Authentic Indian Recipes' },
    authenticDesc: { es: 'Métodos de cocina tradicionales transmitidos a través de generaciones', en: 'Traditional cooking methods passed down through generations' },
    exceptionalService: { es: 'Servicio Excepcional en Madrid', en: 'Exceptional Service in Madrid' },
    exceptionalDesc: { es: 'Hospitalidad cálida y servicio atento en cada visita a nuestros restaurantes', en: 'Warm hospitality and attentive service on every visit to our restaurants' },
    ctaTitle: { 
      es: 'Interesado en Colaborar con Nosotros en España?', 
      en: 'Interested in Partnering with Us in Spain?' 
    },
    ctaSubtitle: { 
      es: 'SP BD Group siempre busca expandir nuestro portfolio de restaurantes con experiencias culinarias excepcionales en Madrid y toda España',
      en: 'SP BD Group is always looking to expand our restaurant portfolio with exceptional culinary experiences in Madrid and across Spain'
    },
    ctaButton: { es: 'Contáctanos en Madrid', en: 'Contact Us in Madrid' }
  },

  // Import/Export page
  importExport: {
    badge: { es: 'COMERCIO INTERNACIONAL DESDE ESPAÑA', en: 'INTERNATIONAL TRADE FROM SPAIN' },
    heroTitle1: { es: 'Conectando', en: 'Connecting' },
    heroTitle2: { es: 'España con el Mundo', en: 'Spain with the World' },
    heroSubtitle: { 
      es: 'Servicios profesionales de importación y exportación facilitando el comercio internacional desde España con experiencia, eficiencia y fiabilidad hacia Europa y más allá.',
      en: 'Professional import and export services facilitating international trade from Spain with expertise, efficiency and reliability to Europe and beyond.'
    },
    exploreServices: { es: 'Explorar Servicios', en: 'Explore Services' },
    requestQuote: { es: 'Solicitar Presupuesto', en: 'Request Quote' },
    servicesTitle: { es: 'Nuestros Servicios de Importación y Exportación', en: 'Our Import and Export Services' },
    servicesSubtitle: { 
      es: 'Soluciones integrales de comercio internacional adaptadas a las necesidades de empresas españolas y europeas',
      en: 'Comprehensive international trade solutions tailored to the needs of Spanish and European businesses'
    },
    internationalTrade: { es: 'Comercio Internacional', en: 'International Trade' },
    internationalTradeDesc: { es: 'Servicios de importación y exportación sin complicaciones conectando mercados globales con logística fiable desde España', en: 'Seamless import and export services connecting global markets with reliable logistics from Spain' },
    supplyChain: { es: 'Gestión de Cadena de Suministro', en: 'Supply Chain Management' },
    supplyChainDesc: { es: 'Soluciones integrales de cadena de suministro optimizando eficiencia y reduciendo costes en Europa', en: 'End-to-end supply chain solutions optimizing efficiency and reducing costs in Europe' },
    marketAnalysis: { es: 'Análisis de Mercado', en: 'Market Analysis' },
    marketAnalysisDesc: { es: 'Insights estratégicos de mercado y análisis para identificar oportunidades comerciales rentables en la UE', en: 'Strategic market insights and analysis to identify profitable trade opportunities in the EU' },
    compliance: { es: 'Cumplimiento y Legal', en: 'Compliance & Legal' },
    complianceDesc: { es: 'Orientación experta en regulaciones de comercio internacional y requisitos legales de la Unión Europea', en: 'Expert guidance on international trade regulations and EU legal requirements' },
    tradeSectorsTitle: { es: 'Sectores de Comercio Internacional', en: 'International Trade Sectors' },
    consumerGoods: { es: 'Bienes de Consumo', en: 'Consumer Goods' },
    consumerGoodsDesc: { es: 'Electrónica, textiles y productos de estilo de vida para el mercado europeo', en: 'Electronics, textiles and lifestyle products for the European market' },
    industrialEquipment: { es: 'Equipos Industriales', en: 'Industrial Equipment' },
    industrialEquipmentDesc: { es: 'Maquinaria, herramientas y equipos de fabricación para empresas españolas', en: 'Machinery, tools and manufacturing equipment for Spanish businesses' },
    foodBeverages: { es: 'Alimentos y Bebidas', en: 'Food & Beverages' },
    foodBeveragesDesc: { es: 'Productos alimentarios premium y bebidas especiales con certificación europea', en: 'Premium food products and specialty beverages with European certification' },
    whyChooseTitle: { es: 'Por Qué Elegir SP BD Group para Comercio Internacional', en: 'Why Choose SP BD Group for International Trade' },
    whyChooseSubtitle: { es: 'Experimenta la ventaja de SP BD Group en comercio internacional desde España', en: 'Experience the SP BD Group advantage in international trade from Spain' },
    globalReach: { es: 'Alcance Global desde España', en: 'Global Reach from Spain' },
    globalReachDesc: { es: 'Acceso a mercados en toda Europa, Asia y Américas desde Madrid', en: 'Access to markets across Europe, Asia and Americas from Madrid' },
    fastProcessing: { es: 'Procesamiento Rápido', en: 'Fast Processing' },
    fastProcessingDesc: { es: 'Despacho de aduanas acelerado y tiempos de respuesta rápidos en la UE', en: 'Expedited customs clearance and fast turnaround times in the EU' },
    secureReliable: { es: 'Seguro y Fiable', en: 'Secure & Reliable' },
    secureReliableDesc: { es: 'Envíos asegurados con seguimiento en tiempo real', en: 'Insured shipments with real-time tracking' },
    expertSupport: { es: 'Soporte Experto 24/7', en: 'Expert Support 24/7' },
    expertSupportDesc: { es: 'Soporte dedicado de especialistas en comercio internacional', en: 'Dedicated support from international trade specialists' },
    statsTitle: { es: 'Nuestros Números en Comercio Internacional', en: 'Our Numbers in International Trade' },
    countries: { es: 'Países en Europa y el Mundo', en: 'Countries in Europe and Worldwide' },
    successfulShipments: { es: 'Envíos Exitosos', en: 'Successful Shipments' },
    clientSatisfaction: { es: 'Satisfacción del Cliente', en: 'Client Satisfaction' },
    customerSupport: { es: 'Soporte al Cliente', en: 'Customer Support' },
    ctaTitle: { es: 'Listo para Expandir tu Negocio Globalmente desde España?', en: 'Ready to Expand Your Business Globally from Spain?' },
    ctaSubtitle: { es: 'Déjanos gestionar tus necesidades de importación y exportación. Contacta con nuestros especialistas en comercio internacional en Madrid hoy.', en: 'Let us handle your import and export needs. Contact our international trade specialists in Madrid today.' },
    freeConsultation: { es: 'Solicitar Consulta Gratuita', en: 'Request Free Consultation' },
    contactWhatsApp: { es: 'Contactar por WhatsApp', en: 'Contact via WhatsApp' }
  },

  // Finance page
  finance: {
    badge: { es: 'SERVICIOS FINANCIEROS PROFESIONALES EN ESPAÑA', en: 'PROFESSIONAL FINANCIAL SERVICES IN SPAIN' },
    heroTitle1: { es: 'Tu Socio en', en: 'Your Partner in' },
    heroTitle2: { es: 'Éxito Financiero', en: 'Financial Success' },
    heroSubtitle: { 
      es: 'Asistencia experta en préstamos, asesoría financiera y apoyo a inversiones para ayudarte a alcanzar tus metas financieras con confianza en España y Europa.',
      en: 'Expert loan assistance, financial advisory and investment support to help you achieve your financial goals with confidence in Spain and Europe.'
    },
    exploreServices: { es: 'Explorar Servicios', en: 'Explore Services' },
    loanCalculator: { es: 'Calculadora de Préstamos', en: 'Loan Calculator' },
    servicesTitle: { es: 'Nuestros Servicios Financieros en Madrid', en: 'Our Financial Services in Madrid' },
    servicesSubtitle: { es: 'Soluciones financieras integrales adaptadas a tus necesidades únicas en España', en: 'Comprehensive financial solutions tailored to your unique needs in Spain' },
    loanAssistance: { es: 'Asistencia en Préstamos', en: 'Loan Assistance' },
    loanAssistanceDesc: { es: 'Orientación experta en el proceso de solicitud de préstamos con tipos competitivos y condiciones flexibles en España', en: 'Expert guidance through the loan application process with competitive rates and flexible terms in Spain' },
    financialGuidance: { es: 'Asesoría Financiera', en: 'Financial Guidance' },
    financialGuidanceDesc: { es: 'Planificación financiera estratégica y servicios de asesoría para ayudarte a alcanzar tus metas financieras en Madrid', en: 'Strategic financial planning and advisory services to help you achieve your financial goals in Madrid' },
    investmentSupport: { es: 'Apoyo a Inversiones', en: 'Investment Support' },
    investmentSupportDesc: { es: 'Asesoramiento profesional de inversiones y gestión de carteras para hacer crecer tu patrimonio en el mercado europeo', en: 'Professional investment advice and portfolio management to grow your wealth in the European market' },
    businessFinance: { es: 'Finanzas Empresariales', en: 'Business Finance' },
    businessFinanceDesc: { es: 'Soluciones financieras integrales para empresas españolas que buscan escalar y tener éxito en Europa', en: 'Comprehensive financial solutions for Spanish businesses looking to scale and succeed in Europe' },
    calculatorTitle: { es: 'Calculadora de Préstamos', en: 'Loan Calculator' },
    calculatorSubtitle: { es: 'Calcula tus pagos mensuales y el coste total del préstamo al instante', en: 'Calculate your monthly payments and total loan cost instantly' },
    loanAmount: { es: 'Importe del Préstamo (EUR)', en: 'Loan Amount (EUR)' },
    interestRate: { es: 'Tipo de Interés TAE (%)', en: 'Interest Rate APR (%)' },
    loanTerm: { es: 'Plazo del Préstamo (Años)', en: 'Loan Term (Years)' },
    loanSummary: { es: 'Resumen de tu Préstamo', en: 'Your Loan Summary' },
    monthlyPayment: { es: 'Cuota Mensual', en: 'Monthly Payment' },
    totalPayment: { es: 'Pago Total', en: 'Total Payment' },
    totalInterest: { es: 'Intereses Totales', en: 'Total Interest' },
    applyNow: { es: 'Solicitar Ahora', en: 'Apply Now' },
    loanOptionsTitle: { es: 'Opciones de Préstamos en España', en: 'Loan Options in Spain' },
    loanOptionsSubtitle: { es: 'Tipos competitivos en múltiples categorías de préstamos', en: 'Competitive rates across multiple loan categories' },
    personalLoans: { es: 'Préstamos Personales', en: 'Personal Loans' },
    personalLoansDesc: { es: 'Financiación flexible para necesidades personales y emergencias en España', en: 'Flexible financing for personal needs and emergencies in Spain' },
    businessLoans: { es: 'Préstamos Empresariales', en: 'Business Loans' },
    businessLoansDesc: { es: 'Capital para hacer crecer y expandir tu negocio en España y Europa', en: 'Capital to grow and expand your business in Spain and Europe' },
    mortgages: { es: 'Hipotecas', en: 'Mortgage Loans' },
    mortgagesDesc: { es: 'Tipos competitivos para tu vivienda ideal en España', en: 'Competitive rates for your ideal home in Spain' },
    autoLoans: { es: 'Préstamos de Coche', en: 'Auto Loans' },
    autoLoansDesc: { es: 'Financiación asequible para tu próximo vehículo', en: 'Affordable financing for your next vehicle' },
    whyChooseTitle: { es: 'Por Qué Elegir Nuestros Servicios Financieros', en: 'Why Choose Our Financial Services' },
    whyChooseSubtitle: { es: 'Tu socio de confianza en el éxito financiero en España', en: 'Your trusted partner in financial success in Spain' },
    secureTrusted: { es: 'Seguro y de Confianza', en: 'Secure & Trusted' },
    secureTrustedDesc: { es: 'Seguridad a nivel bancario y pleno cumplimiento normativo en la UE', en: 'Bank-level security and full EU regulatory compliance' },
    fastApproval: { es: 'Aprobación Rápida', en: 'Fast Approval' },
    fastApprovalDesc: { es: 'Procesamiento rápido con decisiones en 24-48 horas', en: 'Quick processing with decisions in 24-48 hours' },
    expertAdvisors: { es: 'Asesores Expertos', en: 'Expert Advisors' },
    expertAdvisorsDesc: { es: 'Expertos financieros dedicados a tu servicio en Madrid', en: 'Dedicated financial experts at your service in Madrid' },
    flexibleTerms: { es: 'Condiciones Flexibles', en: 'Flexible Terms' },
    flexibleTermsDesc: { es: 'Planes de pago personalizables adaptados a tus necesidades', en: 'Customizable payment plans tailored to your needs' },
    loansGranted: { es: 'Préstamos Concedidos', en: 'Loans Granted' },
    satisfiedClients: { es: 'Clientes Satisfechos', en: 'Satisfied Clients' },
    lowestRate: { es: 'Tipo Más Bajo TAE', en: 'Lowest Rate APR' },
    quickApproval: { es: 'Aprobación Rápida', en: 'Quick Approval' },
    ctaTitle: { es: 'Listo para Dar el Siguiente Paso Financiero?', en: 'Ready to Take Your Next Financial Step?' },
    ctaSubtitle: { es: 'Nuestros expertos financieros en Madrid están listos para ayudarte a alcanzar tus metas. Comienza con una consulta gratuita hoy.', en: 'Our financial experts in Madrid are ready to help you achieve your goals. Start with a free consultation today.' },
    freeConsultation: { es: 'Consulta Gratuita', en: 'Free Consultation' }
  },

  // Advocacy page
  advocacy: {
    badge: { es: 'SERVICIOS JURÍDICOS PROFESIONALES EN ESPAÑA', en: 'PROFESSIONAL LEGAL SERVICES IN SPAIN' },
    heroTitle1: { es: 'Tu Voz', en: 'Your Voice' },
    heroTitle2: { es: 'Tus Derechos', en: 'Your Rights' },
    heroSubtitle: { 
      es: 'Apoyo legal experto, representación comunitaria y orientación en políticas asegurando que tus intereses están protegidos y tu voz sea escuchada en España y Europa.',
      en: 'Expert legal support, community representation and policy guidance ensuring your interests are protected and your voice is heard in Spain and Europe.'
    },
    exploreServices: { es: 'Explorar Servicios', en: 'Explore Services' },
    scheduleConsultation: { es: 'Programar Consulta', en: 'Schedule Consultation' },
    servicesTitle: { es: 'Nuestros Servicios Jurídicos en Madrid', en: 'Our Legal Services in Madrid' },
    servicesSubtitle: { es: 'Soluciones de defensa legal integrales adaptadas a tus necesidades en España', en: 'Comprehensive legal advocacy solutions tailored to your needs in Spain' },
    legalSupport: { es: 'Asesoría Legal', en: 'Legal Support' },
    legalSupportDesc: { es: 'Asesoramiento legal experto y representación para particulares y empresas que navegan asuntos legales complejos en España', en: 'Expert legal advice and representation for individuals and businesses navigating complex legal matters in Spain' },
    communityRepresentation: { es: 'Representación Comunitaria', en: 'Community Representation' },
    communityRepresentationDesc: { es: 'Defensa dedicada asegurando que tu voz sea escuchada en decisiones comunitarias y discusiones de políticas en España', en: 'Dedicated advocacy ensuring your voice is heard in community decisions and policy discussions in Spain' },
    policyGuidance: { es: 'Orientación en Políticas', en: 'Policy Guidance' },
    policyGuidanceDesc: { es: 'Orientación estratégica sobre cumplimiento normativo y desarrollo de políticas para empresas en la Unión Europea', en: 'Strategic guidance on regulatory compliance and policy development for businesses in the European Union' },
    mediationServices: { es: 'Servicios de Mediación', en: 'Mediation Services' },
    mediationServicesDesc: { es: 'Mediación profesional y resolución de conflictos para alcanzar resultados mutuamente beneficiosos', en: 'Professional mediation and conflict resolution to achieve mutually beneficial outcomes' },
    practiceAreasTitle: { es: 'Áreas de Práctica Legal', en: 'Legal Practice Areas' },
    practiceAreasSubtitle: { es: 'Experiencia especializada en múltiples dominios legales y de defensa en España', en: 'Specialized expertise across multiple legal and advocacy domains in Spain' },
    businessLaw: { es: 'Derecho Mercantil', en: 'Business Law' },
    businessLawDesc: { es: 'Gobierno corporativo, contratos y transacciones comerciales en España y la UE', en: 'Corporate governance, contracts and commercial transactions in Spain and the EU' },
    civilRights: { es: 'Derechos Civiles', en: 'Civil Rights' },
    civilRightsDesc: { es: 'Protección de derechos individuales y libertades constitucionales en España', en: 'Protection of individual rights and constitutional freedoms in Spain' },
    immigrationLaw: { es: 'Derecho de Extranjería', en: 'Immigration Law' },
    immigrationLawDesc: { es: 'Solicitudes de visado, residencia y apoyo de ciudadanía en España', en: 'Visa applications, residency and citizenship support in Spain' },
    realEstateLaw: { es: 'Derecho Inmobiliario', en: 'Real Estate Law' },
    realEstateLawDesc: { es: 'Transacciones inmobiliarias, arrendamientos y disputas de bienes raíces', en: 'Real estate transactions, leases and property disputes' },
    whyChooseTitle: { es: 'Por Qué Elegir SP BD Group Abogados', en: 'Why Choose SP BD Group Lawyers' },
    whyChooseSubtitle: { es: 'Defensa legal de confianza con compromiso de excelencia en Madrid y España', en: 'Trusted legal advocacy with a commitment to excellence in Madrid and Spain' },
    provenTrackRecord: { es: 'Historial Probado', en: 'Proven Track Record' },
    provenTrackRecordDesc: { es: 'Más de 15 años de defensa legal exitosa y representación en España', en: 'Over 15 years of successful legal advocacy and representation in Spain' },
    expertTeam: { es: 'Equipo Experto', en: 'Expert Team' },
    expertTeamDesc: { es: 'Profesionales legales experimentados dedicados a tu éxito en Madrid', en: 'Experienced legal professionals dedicated to your success in Madrid' },
    clientFocused: { es: 'Enfoque al Cliente', en: 'Client Focused' },
    clientFocusedDesc: { es: 'Enfoque personalizado adaptado a tus necesidades únicas', en: 'Personalized approach tailored to your unique needs' },
    resultsOriented: { es: 'Orientados a Resultados', en: 'Results Oriented' },
    resultsOrientedDesc: { es: 'Comprometidos a lograr los mejores resultados posibles', en: 'Committed to achieving the best possible outcomes' },
    processTitle: { es: 'Nuestro Proceso Legal', en: 'Our Legal Process' },
    processSubtitle: { es: 'Un enfoque estructurado para ofrecer servicios jurídicos excepcionales en España', en: 'A structured approach to delivering exceptional legal services in Spain' },
    initialConsultation: { es: 'Consulta Inicial', en: 'Initial Consultation' },
    initialConsultationDesc: { es: 'Entender tus necesidades y objetivos legales', en: 'Understand your legal needs and objectives' },
    strategyDevelopment: { es: 'Desarrollo de Estrategia', en: 'Strategy Development' },
    strategyDevelopmentDesc: { es: 'Crear un plan de defensa personalizado', en: 'Create a customized advocacy plan' },
    implementation: { es: 'Implementación', en: 'Implementation' },
    implementationDesc: { es: 'Ejecutar con precisión y cuidado', en: 'Execute with precision and care' },
    ongoingSupport: { es: 'Soporte Continuo', en: 'Ongoing Support' },
    ongoingSupportDesc: { es: 'Orientación continua y actualizaciones', en: 'Continuous guidance and updates' },
    casesResolved: { es: 'Casos Resueltos en España', en: 'Cases Resolved in Spain' },
    successRate: { es: 'Tasa de Éxito', en: 'Success Rate' },
    yearsExperience: { es: 'Años de Experiencia', en: 'Years of Experience' },
    customerSupport: { es: 'Soporte al Cliente', en: 'Customer Support' },
    ctaTitle: { es: 'Necesitas Asesoría Legal en Madrid?', en: 'Need Legal Advice in Madrid?' },
    ctaSubtitle: { es: 'Nuestro equipo experimentado de abogados en Madrid está listo para representar tus intereses y proteger tus derechos. Programa una consulta hoy.', en: 'Our experienced team of lawyers in Madrid is ready to represent your interests and protect your rights. Schedule a consultation today.' },
    callUs: { es: 'Llamar', en: 'Call Us' }
  },

  // Common
  common: {
    learnMore: { es: 'Saber Más', en: 'Learn More' },
    getStarted: { es: 'Empezar', en: 'Get Started' },
    contactUs: { es: 'Contáctanos', en: 'Contact Us' },
    readMore: { es: 'Leer Más', en: 'Read More' },
    viewAll: { es: 'Ver Todo', en: 'View All' },
    years: { es: 'Años', en: 'Years' },
    from: { es: 'Desde', en: 'From' },
    explore: { es: 'Explorar', en: 'Explore' },
    submit: { es: 'Enviar', en: 'Submit' },
    sending: { es: 'Enviando...', en: 'Sending...' },
    all: { es: 'Todos', en: 'All' },
    loading: { es: 'Cargando...', en: 'Loading...' }
  },

  // Home page
  home: {
    exploreService: { es: 'Explorar', en: 'Explore' },
    getInTouch: { es: 'Contactar', en: 'Get in Touch' },
    ourBusinesses: { es: 'Nuestros Negocios', en: 'Our Businesses' },
    ourBusinessesSubtitle: { 
      es: 'Descubre nuestra diversa cartera de negocios diseñados para servir a tus necesidades en España',
      en: 'Discover our diverse portfolio of businesses designed to serve your needs in Spain'
    },
    whyChooseUs: { es: 'Por Qué Elegirnos', en: 'Why Choose Us' },
    whyChooseUsSubtitle: { 
      es: 'Nuestra experiencia combinada abarca múltiples industrias con un enfoque en la excelencia',
      en: 'Our combined experience spans multiple industries with a focus on excellence'
    },
    yearsExperience: { es: 'Años de Experiencia', en: 'Years of Experience' },
    activeBusinesses: { es: 'Negocios Activos', en: 'Active Businesses' },
    satisfiedClients: { es: 'Clientes Satisfechos', en: 'Satisfied Clients' },
    countriesServed: { es: 'Países Atendidos', en: 'Countries Served' },
    readyToStart: { es: '¿Listo para Empezar?', en: 'Ready to Get Started?' },
    readyToStartSubtitle: { 
      es: 'Contacta con nosotros hoy para discutir cómo podemos ayudarte a alcanzar tus objetivos empresariales en España',
      en: 'Contact us today to discuss how we can help you achieve your business goals in Spain'
    },
    scheduleConsultation: { es: 'Programar Consulta', en: 'Schedule Consultation' },
    callNow: { es: 'Llamar Ahora', en: 'Call Now' }
  },

  // Contact page
  contact: {
    heroTitle: { es: 'Contáctanos', en: 'Contact Us' },
    heroSubtitle: { 
      es: '¿Tienes preguntas o necesitas asistencia? Ponte en contacto con nosotros y te responderemos lo antes posible.',
      en: 'Have questions or need assistance? Reach out to us and we\'ll get back to you as soon as possible.'
    },
    getInTouch: { es: 'Ponte en Contacto', en: 'Get in Touch' },
    sendMessage: { es: 'Enviar Mensaje', en: 'Send Message' },
    formTitle: { es: 'Envíanos un Mensaje', en: 'Send Us a Message' },
    formSubtitle: { 
      es: 'Completa el formulario y nos pondremos en contacto contigo pronto',
      en: 'Fill out the form and we\'ll get back to you soon'
    },
    yourName: { es: 'Tu Nombre', en: 'Your Name' },
    yourEmail: { es: 'Tu Email', en: 'Your Email' },
    yourPhone: { es: 'Tu Teléfono', en: 'Your Phone' },
    businessType: { es: 'Tipo de Negocio', en: 'Business Type' },
    selectBusinessType: { es: 'Selecciona tipo de negocio', en: 'Select business type' },
    yourMessage: { es: 'Tu Mensaje', en: 'Your Message' },
    messagePlaceholder: { es: 'Cuéntanos cómo podemos ayudarte...', en: 'Tell us how we can help you...' },
    successMessage: { 
      es: '¡Mensaje enviado con éxito! Nos pondremos en contacto contigo pronto.',
      en: 'Message sent successfully! We\'ll get back to you soon.'
    },
    sendAnother: { es: 'Enviar Otro Mensaje', en: 'Send Another Message' },
    contactInfo: { es: 'Información de Contacto', en: 'Contact Information' },
    officeLocations: { es: 'Ubicaciones de Oficinas', en: 'Office Locations' },
    businessHours: { es: 'Horario de Atención', en: 'Business Hours' },
    whatsappChat: { es: 'Chat por WhatsApp', en: 'WhatsApp Chat' },
    startWhatsapp: { es: 'Iniciar Chat de WhatsApp', en: 'Start WhatsApp Chat' }
  },

  // Blog page
  blog: {
    heroTitle: { es: 'Nuestro Blog', en: 'Our Blog' },
    heroSubtitle: { 
      es: 'Insights, noticias y consejos expertos de nuestro equipo',
      en: 'Insights, news and expert tips from our team'
    },
    latestArticles: { es: 'Últimos Artículos', en: 'Latest Articles' },
    featuredPost: { es: 'Artículo Destacado', en: 'Featured Post' },
    allCategories: { es: 'Todas las Categorías', en: 'All Categories' },
    filterByCategory: { es: 'Filtrar por Categoría', en: 'Filter by Category' },
    readArticle: { es: 'Leer Artículo', en: 'Read Article' },
    minRead: { es: 'min de lectura', en: 'min read' },
    by: { es: 'Por', en: 'By' },
    noArticles: { es: 'No hay artículos en esta categoría', en: 'No articles in this category' },
    loadingArticles: { es: 'Cargando artículos...', en: 'Loading articles...' },
    categories: {
      all: { es: 'Todos', en: 'All' },
      finance: { es: 'Finanzas', en: 'Finance' },
      realEstate: { es: 'Inmobiliaria', en: 'Real Estate' },
      advocacy: { es: 'Legal', en: 'Legal' },
      restaurants: { es: 'Restaurantes', en: 'Restaurants' },
      importExport: { es: 'Comercio Internacional', en: 'International Trade' }
    }
  },

  // Footer
  footer: {
    description: { 
      es: 'SP BD Group es un conglomerado empresarial premium en España con operaciones diversificadas en restaurantes, inmobiliaria, finanzas, servicios jurídicos y comercio internacional.',
      en: 'SP BD Group is a premium business conglomerate in Spain with diversified operations in restaurants, real estate, finance, legal services and international trade.'
    },
    quickLinks: { es: 'Enlaces Rápidos', en: 'Quick Links' },
    ourServices: { es: 'Nuestros Servicios', en: 'Our Services' },
    contactInfo: { es: 'Información de Contacto', en: 'Contact Info' },
    allRightsReserved: { es: 'Todos los derechos reservados', en: 'All rights reserved' },
    developedBy: { es: 'Desarrollado por', en: 'Developed by' }
  }
};

// Language Provider Component
export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    // Check localStorage for saved preference, default to Spanish
    if (typeof window !== 'undefined') {
      return localStorage.getItem('spbd-language') || 'es';
    }
    return 'es';
  });

  useEffect(() => {
    // Save language preference to localStorage
    localStorage.setItem('spbd-language', language);
    // Update HTML lang attribute
    document.documentElement.lang = language === 'es' ? 'es' : 'en';
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'es' ? 'en' : 'es');
  };

  const t = (key) => {
    // Navigate to the translation using dot notation (e.g., 'nav.home')
    const keys = key.split('.');
    let value = translations;
    for (const k of keys) {
      if (value && value[k]) {
        value = value[k];
      } else {
        return key; // Return key if translation not found
      }
    }
    return value[language] || value['en'] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

// Custom hook to use language context
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}

export default LanguageContext;
